import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LayoutComponent } from './layout.component';

const routes: Routes = [
    {
        path: '',
        component: LayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () =>
                    import('../park/park.module').then((mod) => mod.ParkModule),
            },
            {
                path: 'list-template',
                loadChildren: () =>
                    import('../list-template/list-template.module').then(
                        (mod) => mod.ListTemplateModule
                    ),
            },
            {
                path: 'park',
                loadChildren: () =>
                    import('../park/park.module').then((mod) => mod.ParkModule),
            },
            {
                path: 'spots',
                loadChildren: () =>
                    import('../spots/spots.module').then(
                        (mod) => mod.SpotsModule
                    ),
            },
            {
                path: 'account-detail',
                loadChildren: () =>
                    import('../account-detail/account-detail.module').then(
                        (mod) => mod.AccountDetailModule
                    ),
            },
            {
                path: 'private-campaign',
                loadChildren: () =>
                    import('../private-campaign/private-campaign.module').then(
                        (mod) => mod.PrivateCampaignModule
                    ),
            },
            {
                path: 'tickets',
                loadChildren: () =>
                    import('../ticket/ticket.module').then(
                        (mod) => mod.TicketModule
                    ),
            },
            {
                path: 'medias',
                loadChildren: () =>
                    import('../media-library/media-library.module').then(
                        (mod) => mod.MediaLibraryModule
                    ),
            },
            {
                path: 'store',
                loadChildren: () =>
                    import('../store/store.module').then(
                        (mod) => mod.StoreModule
                    ),
            },
            {
                path: 'timeline',
                loadChildren: () =>
                    import('../campaigns/campaign.module').then(
                        (mod) => mod.CampaignsModule
                    ),
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class LayoutRoutingModule {}
